import { render, staticRenderFns } from "./TypeField.vue?vue&type=template&id=0b4f1fa0"
import script from "./TypeField.vue?vue&type=script&lang=js"
export * from "./TypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports